const ReasonForSaleType = {
  TO_REPLACE_OR_RELOCATE: "買い替え・住み替えのため",
  DUE_TO_FINANCIAL_REASONS: "金銭的理由のため",
  DIFFICULT_TO_PAY_THE_MORTGAGE: "住宅ローン返済が苦しいため",
  INHERIGTED_THE_PROPERTY: "物件を相続したため",
  TO_LIQUIDATE_ASSETS: "資産整理のため",
  OWNER_IS_OLD: "所有者が高齢のため",
  DUE_TO_VACANT_HOUSE: "空き家のため",
  DUE_TO_DIVORCE: "離婚のため",
  DUE_TO_JOB_TRANSFER: "転勤のため",
  DISSATISFIED_WITH_THE_COMPANY: "契約中の会社の対応が不満で別の会社を探しているため",
  NO_INTENTION_OF_SELLING: "売却の意思はない",
  OTHER: "その他",
  DO_NOT_WANT_TO_ANSWER_NOW: "今は答えたくない",
} as const;

export const reasonForSaleTypeOptions = Object.values(ReasonForSaleType).map(value => ({
  label: value,
  value,
}));

export default ReasonForSaleType;
